import { ImpersonateData } from 'adminPanel/types';
import api from 'services/api';

export const impersonateUser = (userId: number): Promise<ImpersonateData> => {
    return api.post(`/users/impersonate/${userId}`).then(({ data }) => data);
};
